import { gql } from "@apollo/client";

export const ORDER_COMMITION = gql`
query GetCommitionAmount {
  getCommitionAmount {
    id
    sameDay_order_percentage
    weightCommissions {
      weight
      cod_order_percentage
      freight_charge_percentage
    }
  }
}
`

export const INSERT_COMMITION = gql`
mutation UpsertCommition($sameDayOrderPercentage: Float, $weightCommissions: [WeightCommissionInput]) {
  upsertCommition(sameDay_order_percentage: $sameDayOrderPercentage, weightCommissions: $weightCommissions) {
    id
    sameDay_order_percentage
    weightCommissions {
      weight
      cod_order_percentage
      freight_charge_percentage
    }
  }
}
`
export const GET_COMMISION_BY_WEIGHT = gql`
query GetCommitionByWeight($weight: Float!) {
  getCommitionByWeight(weight: $weight) {
    weight
    cod_order_percentage
    freight_charge_percentage
  }
}
`